import { FACEBOOK_DEMOGRAPHICS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function fbDemographics(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case FACEBOOK_DEMOGRAPHICS:
    //  console.log("data inside reducer after the ajax call =  ", action.type)
    //   // const parsedData = JSON.parse(action.payload.data)
    //   console.log("statesd", state)
      return { ...state, data: action.payload.data.data, errors: null };
      
    default:
      return state;
  }
}